<button
  pButton
  type="button"
  label="Create Next Review Period Request"
  [disabled]="!skillCodesForPeriodB?.length"
  (click)="createNextReviewPeriod()"
></button>